import { useCallback } from "react";

import { Auth } from "../../amplify/amplify";
import { parseAuthResult } from "../../amplify/amplify.helpers";

export const useAuthenticatedSession = () => {
  const getAccessToken = useCallback(async () => {
    const result = parseAuthResult(await Auth.currentAuthenticatedUser());
    return result.accessToken?.jwt;
  }, []);

  const getIdToken = useCallback(async () => {
    const result = parseAuthResult(await Auth.currentAuthenticatedUser());
    return result.idToken?.jwt;
  }, []);

  return {
    getAccessToken,
    getIdToken,
  };
};
